import React from 'react';
import PropTypes from 'prop-types';

import { Criterium, CriteriumSocialSection } from '@hydra/common/criterium';

import { useI18n } from '@hydra/common/customHooks';

export const TwitterAccount = ({ criterium }) => {
  const { moment } = useI18n();
  const { data, url } = criterium;
  const {
    name,
    profileBannerUrl,
    followers,
    tweets,
    bio,
    created,
    location,
    'screen-name': screenName,
    urlLinked,
    confidence,
    urls
  } = data;

  const isDetected = data?.urls?.length > 0;

  const content = (
    <CriteriumSocialSection
      isDetected={isDetected}
      network='Twitter'
      image={profileBannerUrl}
      username={screenName}
      urlLinked={urlLinked}
      confidence={confidence}
      urls={urls}
      sections={[
        { name: 'twitter_account_url', node: `https://www.twitter.com/${screenName}` },
        { name: 'twitter_account_name', node: name },
        { name: 'twitter_account_followers', node: followers },
        { name: 'twitter_account_tweets', node: tweets },
        { name: 'twitter_account_bio', node: bio },
        { name: 'twitter_account_location', node: location },
        { name: 'twitter_account_age', node: created && moment(new Date(created)).fromNow() }
      ]}
    />
  );

  return (
    <Criterium
      criterium={criterium}
      variables={{ domain: url }}
    >
      {content}
    </Criterium>
  );
};

TwitterAccount.propTypes = {
  criterium: PropTypes.shape({
    data: PropTypes.object
  })
};

export default React.memo(TwitterAccount);
